module.exports = __webpack_public_path__ + "static/media/cart.9eb1f4fc.svg";